import { render, staticRenderFns } from "./ImageWithBorderDialog.vue?vue&type=template&id=a68483a8&scoped=true&"
import script from "./ImageWithBorderDialog.vue?vue&type=script&lang=js&"
export * from "./ImageWithBorderDialog.vue?vue&type=script&lang=js&"
import style0 from "./ImageWithBorderDialog.vue?vue&type=style&index=0&id=a68483a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68483a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
